import _ from 'underscore';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fluentui/react-components';
import { ArrowClockwiseRegular, DismissRegular } from '@fluentui/react-icons';

import { usePerformanceFilterBarEditingStyle } from './styles';

const EditingFilterBar = ({
  filters,
  focusedFilter,
  onRenderNewFilterContextMenu,
  onRenderFilter,
  onCloseClick,
  onResetClick,
  i18n,
}) => {
  const classes = usePerformanceFilterBarEditingStyle();
  // if no editing filter, show new filter context menu

  const getDivider = (index) => {
    if (index === filters.length - 1) {
      return null;
    }
    return (<span className="filter-list-divider" />);
  };

  return (
    <div className={classNames('filterBarEditingContainer', classes.filterBarEditingContainer)}>
      <div className="filter-list-editing">
        {filters.map((filter, index) => (
          <Fragment key={`filter-${filter.id}`}>
            {onRenderFilter({
              filter,
              focused: focusedFilter && focusedFilter.id === filter.id,
              index,
              isLast: index === filters.length - 1,
              isFirst: index === 0,
            })}
            {getDivider(index)}
          </Fragment>
        ))}
        {onRenderNewFilterContextMenu()}
      </div>
      <div className="filter-bar-button-group">
        <Button
          onClick={onResetClick}
          className="filter-bar-button reset-button"
          aria-label={i18n.getString(_TL_('Reset filter to default state'))}
          icon={<ArrowClockwiseRegular />}
        >
          {i18n.getString(_TL_('Reset'))}
        </Button>
        <div className="filter-bar-divider" />
        <Button
          onClick={onCloseClick}
          className="filter-bar-cancel-button filter-bar-button"
          aria-label={i18n.getString(_TL_('Close filter panel'))}
          icon={<DismissRegular />}
        />
      </div>
    </div>
  );
};

EditingFilterBar.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  focusedFilter: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onRenderNewFilterContextMenu: PropTypes.func,
  onRenderFilter: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func,
  onResetClick: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

EditingFilterBar.defaultProps = {
  filters: [],
  focusedFilter: null,
  onRenderNewFilterContextMenu: () => null,
  onCloseClick: _.noop,
  onResetClick: _.noop,
};

export const PerformanceEditingFilterBar
  = React.memo(EditingFilterBar);
